/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  BUTTON_FORMAT_TRANSPARENT,
  BUTTON_THEME_DEFAULT,
  ButtonProps,
  DIALOG_SIZE_SM_MD,
  DialogContentProps,
  DialogProps,
  ICON_EDIT,
} from '@squiz/sds';
import { useDialogStore } from 'dxpConsoleCore-mf/State';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogLauncher } from '../../../../Components/DialogLauncher/DialogLauncher';
import { CORE_STRINGS } from '../../../../Constants/Strings.constants';
import { SETTING_LIST_DATA_IDS } from '../../SettingList.constants';
import { SettingEditForm } from '../../forms/SettingEditForm/SettingEditForm';
import { SettingEditProps } from './SettingEdit.props';

/**
 * The setting edit dialog launcher.
 */
export const SettingEdit = (props: SettingEditProps): JSX.Element => {
  const { t } = useTranslation();
  const { clearCache, keyName, schemas, setting } = props;

  // Labels
  const labels = useMemo(() => {
    return {
      edit: t(CORE_STRINGS.edit),
      editSetting: t(CORE_STRINGS.editSetting),
    };
  }, [t]);

  const buttonProps: ButtonProps = {
    format: BUTTON_FORMAT_TRANSPARENT,
    icon: ICON_EDIT,
    label: labels.edit,
    theme: BUTTON_THEME_DEFAULT,
  };

  const dialogProps: DialogProps = {
    dialogContent: {
      renderContent: (props: DialogContentProps): JSX.Element => {
        const formProps = { ...props };
        formProps.customProps = { clearCache, keyName, schemas, setting };

        return <SettingEditForm {...formProps} />;
      },
    },
    dialogSize: DIALOG_SIZE_SM_MD,
    heading: labels.editSetting,
    showDividers: true,
    stateHandler: useDialogStore,
  };

  return (
    <div className="service-settings__edit" data-id={SETTING_LIST_DATA_IDS.editSettingButton}>
      <DialogLauncher buttonProps={buttonProps} dialogProps={dialogProps} />
    </div>
  );
};
